"use client";

import Header from "../../Common/Header";
import { UserCompanyTable } from "../UserCompanyTable";
import { Box, Typography } from "@mui/material";

export default function CompanyAdminPage() {
  return (
    <Box sx={{ backgroundColor: "#F9FAFB", minHeight: "100vh" }}>
      <Header />

      <Box
        sx={{
          maxWidth: "1400px",
          margin: "0 auto",
          padding: { xs: "12px", sm: "24px" },
        }}
      >
        <Typography
          sx={{
            fontSize: "28px",
            fontWeight: 700,
            color: "#111827",
            mb: 0.5,
          }}
        >
          Company Admin
        </Typography>

        <Typography sx={{ fontSize: "14px", color: "#6B7280", mb: 3 }}>
          Manage users in your company
        </Typography>

        <Box
          sx={{
            backgroundColor: "#FFFFFF",
            borderRadius: "16px",
            border: "1px solid #E5E7EB",
            padding: "0",
            overflow: "hidden",
          }}
        >
          <UserCompanyTable 
           isSuperAdmin={false}
          />
        </Box>
      </Box>
    </Box>
  );
}
